import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Star, Quote, ArrowLeft, ArrowRight } from "lucide-react";
import { BUSINESS, REVIEWS } from "@/data/content";

export default function Reviews() {
  const [[i, dir], setState] = useState([0, 0]);
  const [paused, setPaused] = useState(false);
  const paginate = (d) => {
    const next = (i + d + REVIEWS.length) % REVIEWS.length;
    setState([next, d]);
  };
  useEffect(() => {
    if (paused) return;
    const id = setInterval(() => {
      setState(([prev]) => [(prev + 1) % REVIEWS.length, 1]);
    }, 5000);
    return () => clearInterval(id);
  }, [paused]);
  const r = REVIEWS[i];

  return (
    <section
      id="recensioni"
      className="bg-[#2A1B14] text-[#FDFBF7] py-16 sm:py-20"
      data-testid="reviews-section"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div className="max-w-[1200px] mx-auto px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14">
          <div>
            <p className="font-body text-xs tracking-[0.28em] uppercase text-[#D4AF37] mb-4">
              La voce dei clienti
            </p>
            <h2 className="font-display font-light tracking-tight leading-[0.95] text-[clamp(2.5rem,6vw,5rem)]">
              Amati a <span className="italic">Chiarano</span>
            </h2>
          </div>

          <a
            href={BUSINESS.reviewsUrl}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-4 rounded-2xl border border-[#FDFBF7]/15 px-6 py-4 hover:bg-[#FDFBF7]/5 hover:border-[#FDFBF7]/30 transition-colors duration-300"
            data-testid="google-badge"
          >
            <div className="text-4xl font-display leading-none text-[#D4AF37]">
              {BUSINESS.rating}
            </div>
            <div>
              <div className="flex gap-0.5 mb-1">
                {[0, 1, 2, 3, 4].map((s) => (
                  <Star key={s} size={14} className="fill-[#D4AF37] text-[#D4AF37]" />
                ))}
              </div>
              <p className="font-body text-xs text-[#FDFBF7]/70">
                {BUSINESS.reviewsCount} recensioni · Google
              </p>
            </div>
          </a>
        </div>

        <div className="relative min-h-[280px] sm:min-h-[240px]">
          <AnimatePresence mode="wait" custom={dir}>
            <motion.blockquote
              key={i}
              custom={dir}
              initial={{ opacity: 0, x: dir >= 0 ? 60 : -60 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: dir >= 0 ? -60 : 60 }}
              transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
              className="max-w-3xl"
              data-testid={`review-${i}`}
            >
              <Quote size={44} className="text-[#D4AF37] mb-6" />
              <p className="font-display font-light text-[clamp(1.6rem,4vw,2.75rem)] leading-[1.15] tracking-tight">
                “{r.text}”
              </p>
              <footer className="mt-8 flex items-center gap-4">
                <span className="h-11 w-11 rounded-full bg-[#8C9B86] text-[#1A2017] grid place-items-center font-display text-xl">
                  {r.name.charAt(0)}
                </span>
                <div>
                  <div className="font-body font-semibold">{r.name}</div>
                  <div className="font-body text-xs text-[#FDFBF7]/60">{r.note}</div>
                </div>
              </footer>
            </motion.blockquote>
          </AnimatePresence>
        </div>

        <div className="flex items-center gap-4 mt-10">
          <button
            onClick={() => paginate(-1)}
            className="h-12 w-12 rounded-full border border-[#FDFBF7]/25 grid place-items-center hover:bg-[#FDFBF7] hover:text-[#2A1B14] transition-colors duration-300"
            aria-label="Recensione precedente"
            data-testid="review-prev"
          >
            <ArrowLeft size={18} />
          </button>
          <button
            onClick={() => paginate(1)}
            className="h-12 w-12 rounded-full border border-[#FDFBF7]/25 grid place-items-center hover:bg-[#FDFBF7] hover:text-[#2A1B14] transition-colors duration-300"
            aria-label="Recensione successiva"
            data-testid="review-next"
          >
            <ArrowRight size={18} />
          </button>
          <div className="ml-2 flex gap-2">
            {REVIEWS.map((_, idx) => (
              <span
                key={idx}
                className={`h-1.5 rounded-full transition-all duration-300 ${
                  idx === i ? "w-8 bg-[#D4AF37]" : "w-1.5 bg-[#FDFBF7]/30"
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
